import { render, staticRenderFns } from "./Textracts.vue?vue&type=template&id=11d92648&"
import script from "./Textracts.vue?vue&type=script&lang=js&"
export * from "./Textracts.vue?vue&type=script&lang=js&"
import style0 from "./Textracts.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports